import styled from 'styled-components';

const graydiant05 = '#ccc';
const graydiant06 = '#999';
const graydiant07 = '#666';
const graydiant08 = '#333';

export const Card = styled.div`
  position: relative;
  float: left;
  width: 316px;
  height: 106px;
  background: white;
  -moz-box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  -webkit-box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  margin: 18px 12px 18px 12px !important;
  border-radius: 3px;
`;

export const StudentGroups = styled.div`
  padding: 8px 0 16px 16px;
  height: 46px;
  width: 100%;
`;

export const GroupLetter = styled.div`
  float: left;
  border-radius: 50%;
  font-size: 12px;
  text-transform: uppercase;
  margin-right: 4px;
  width: 22px;
  text-align: center;
  color: ${props => props.letterStyle.color || ''};
  border: solid 2px ${props => props.letterStyle.borderColor || ''};
`;

export const NoImage = styled.img`
  width: 106px;
  height: 106px;
  border-bottom-left-radius: 3px;
  border-top-left-radius: 3px;
  opacity: 1;
`;

export const Image = styled.img`
  width: 106px;
  height: 106px;
  opacity: ${props => (props.isEnabled === 1 ? 1 : 0.2)};
`;

export const MoreVert = styled.div`
  margin-top: 16px;
  margin-right: 16px;
  color: ${graydiant06};
  max-height: 18px;

  &:hover {
    cursor: pointer;
    color: ${graydiant08};
  }

  opacity: ${props => (props.isDragging === 'opacity-100' ? 'opacity: 1' : 'opacity: 0.2')};
`;

export const GreenBall = styled.div`
  background: #6ce800;
  height: 14px;
  width: 14px;
  border-radius: 50%;
  border: 1px solid #fffae4;
  position: absolute;
  margin-left: 12px;
  margin-top: 12px;
  z-index: 30;
`;

export const GreyBall = styled.div`
  background: #c6c2c7;
  height: 14px;
  width: 14px;
  border-radius: 50%;
  border: 1px solid #fffae4;
  position: absolute;
  margin-left: 12px;
  margin-top: 12px;
  z-index: 30;
`;

export const CardContent = styled.div`
  padding: 0 !important;
  width: 111px;
  opacity: ${props => (props.isEnabled === 1 ? 1 : 0.2)};
`;

export const CardName = styled.div`
  width: 160px;
  height: 60px;
  max-height: 60px;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  -moz-box-orient: vertical;
  -moz-line-clamp: 2;
  box-orient: vertical;
  line-clamp: 2;
  padding: 16px 0 0 16px;
  font-family: 'Lato', 'DefaultLato', 'sans-serif';
  font-size: 18px;
  color: ${graydiant07};
  display: -webkit-box;
  display: -moz-box;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.2;
`;

export const CardMosaic = styled.div`
  height: 100%;
  width: 95%;
  z-index: 10;
  padding-top: 25px;
  &.empty {
    width: 100%;
  }
`;

export const AddGroup = styled.div`
  margin: 0 auto 24px auto;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  border: dashed 2px ${graydiant05};

  &:hover,
  &:focus {
    border: dashed 2px ${graydiant07};
    cursor: pointer;
    color: ${graydiant07};
  }

  color: ${graydiant05};
  padding: 16px;
`;

export const TeacherRole = styled.div`
  color: #999999;
  padding-left: 17px;
  padding-top: 12px;
  font-size: 11px;
  font-family: 'Lato', 'DefaultLato', 'sans-serif';
`;
